<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <h4 class="font-weight-semibold mb-3 mb-md-4">Are you sure you want to remove this plant information</h4>
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="text-left">
        <div class="form-group floating_form_field mb-0 w-100">
            <textarea formControlName="DeleteRemarks" id="DeleteRemarks" class="form-control"
                placeholder="Why do you want to delete this plant information?" required></textarea>
            <label>Why do you want to delete this plant information?</label>
        </div>
        <div *ngIf="myForm.get('DeleteRemarks').invalid && myForm.get('DeleteRemarks').touched" class="small text-danger">
            <div *ngIf="myForm.get('DeleteRemarks').errors?.required">Reason is required</div>
            <div *ngIf="myForm.get('DeleteRemarks').errors?.maxlength">The Reason may not be longer than 500 charecters</div>
        </div>
        <div class="d-flex align-items-center column-gap-3 mt-3 mt-md-4 mt-lg-5">
            <button class="btn btn-clear w-50" type="button" (click)="modal.dismiss()">Cancel</button>
            <button class="btn btn-primary w-50" type="submit">Remove</button>
        </div>
    </form>
</div>